import type { UseUserData } from '../user/useUser'
import { useMutation } from '@tanstack/vue-query'
import queryClient, { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useMarkNotificationsRead() {
  const userData = computed(() => queryClient.getQueryData<UseUserData>(queryKeys.USER()))
  const userId = computed(() => userData.value?.id ?? 0)

  return useMutation({
    mutationFn: async () => {
      const res = await financialBff('mutation')({
        markNotificationsRead: [
          { userId: userId.value },
          true,
        ],
      })
      return res.markNotificationsRead
    },
  })
}
